import React,{useState,useRef, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Button, TextField,Stack, Divider} from "@mui/material";
import { useDispatch } from 'react-redux';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';

function NtwSqlTemplate() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [sqlFileVal,setSqlFileVal] = useState('');
    // const [isSqlValid,setIsSqlValid] = useState(false);
    const fileBrowser = useRef();
    const error = useRef();
    const label = `Choose SQL File`;
    const handleUploadClick = (e) => {
      const file = e.target.files[0];
      setSqlFileVal(file.name)
      const fileNameWithoutExtension = file.name.split('.').slice(0,-1).join('.')
      dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension))

      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileInfo = e.target.result;
          dispatch(newTemplateActions.setSqlTemplateData({ fileInfo }));
        };
        reader.readAsText(file);
      }
    };
    
    useEffect(()=>{
      dispatch(newTemplateActions.setIsFormData(true))
    },[])
  return (
    <>
      <Stack spacing={"8x"}>
        <div className="flex">
          <TextField
            className="width-100"
            label={label}
            variant="outlined"
            size="small"
            value={sqlFileVal}
            autoComplete='off'
            onChange={(e) => {
              // setDtdFileVal(e.target.value);
              error.current.textContent = "";
              // handleChange("FILE", e);
            }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setSqlFileVal(e.target.value);
              error.current.textContent = "";
            //   setIsSqlValid(false);
            //   handleChange("FILE_PATH", e);
              handleUploadClick(e);
            }}
          />
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
            <DriveFolderUploadIcon fontSize="small" />
          </Button>
          <div>
            <p className="error" ref={error}></p>
          </div>
        </div>
      </Stack>
    </>
  );
}

export default NtwSqlTemplate